import React, { useState, useEffect, useCallback } from 'react';
import './StoreCarousel.css';

const StoreCarousel = ({ slides, autoplayInterval = 5000, height = '500px', variant = 'default' }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  // Navegación
  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Autoplay
  useEffect(() => {
    if (!isPlaying) return;

    const interval = setInterval(() => {
      nextSlide();
    }, autoplayInterval);

    return () => clearInterval(interval);
  }, [isPlaying, nextSlide, autoplayInterval]);

  // Pausar en hover
  const handleMouseEnter = () => setIsPlaying(false);
  const handleMouseLeave = () => setIsPlaying(true);

  return (
    <div 
      className={`store-carousel ${variant === 'tienda' ? 'store-carousel-tienda' : ''}`}
      style={{ height }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Slides */}
      <div className="carousel-slides">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
          >
            {/* Contenido: Imagen o Video */}
            {slide.type === 'video' ? (
              <video
                className="carousel-media"
                src={slide.src}
                autoPlay
                loop
                muted
                playsInline
              />
            ) : (
              <img
                className="carousel-media"
                src={slide.src}
                alt={slide.title || `Slide ${index + 1}`}
                loading="eager"
                onError={(e) => {
                  if (slide.fallbackSrc && e.target.src !== slide.fallbackSrc) {
                    e.target.src = slide.fallbackSrc;
                  }
                }}
              />
            )}

            {/* Overlay con gradiente - más suave en tienda para ver las imágenes IA */}
            <div className="carousel-overlay"></div>

            {/* Contenido de texto */}
            {(slide.title || slide.description || slide.cta) && (
              <div className="carousel-content">
                {slide.subtitle && (
                  <p className="carousel-subtitle">{slide.subtitle}</p>
                )}
                {slide.title && (
                  <h2 className="carousel-title">{slide.title}</h2>
                )}
                {slide.description && (
                  <p className="carousel-description">{slide.description}</p>
                )}
                {slide.cta && (
                  <button className="carousel-cta" onClick={slide.cta.onClick}>
                    {slide.cta.text}
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Controles de navegación */}
      {slides.length > 1 && (
        <>
          <button 
            className="carousel-control carousel-prev" 
            onClick={prevSlide}
            aria-label="Slide anterior"
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button 
            className="carousel-control carousel-next" 
            onClick={nextSlide}
            aria-label="Slide siguiente"
          >
            <i className="fas fa-chevron-right"></i>
          </button>

          {/* Indicadores */}
          <div className="carousel-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Ir a slide ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default StoreCarousel;

